export const Countries = [
  // North America
  { id: 1, name: "USA", code: "US", phoneCode: "+1", currency: "USD", symbol: "$", region: "NORTH_AMERICA" },
  { id: 2, name: "Canada", code: "CA", phoneCode: "+1", currency: "CAD", symbol: "C$", region: "NORTH_AMERICA" },
  { id: 3, name: "Mexico", code: "MX", phoneCode: "+52", currency: "MXN", symbol: "$", region: "NORTH_AMERICA" },

  // Oceania
  { id: 4, name: "Australia", code: "AU", phoneCode: "+61", currency: "AUD", symbol: "A$", region: "OCEANIA" },
  { id: 5, name: "New Zealand", code: "NZ", phoneCode: "+64", currency: "NZD", symbol: "NZ$", region: "OCEANIA" },

  // Asia
  { id: 6, name: "Singapore", code: "SG", phoneCode: "+65", currency: "SGD", symbol: "S$", region: "ASIA" },
  { id: 7, name: "India", code: "IN", phoneCode: "+91", currency: "INR", symbol: "₹", region: "ASIA" },
  { id: 8, name: "UAE", code: "AE", phoneCode: "+971", currency: "AED", symbol: "د.إ", region: "ASIA" },

  // Europe
  { id: 9, name: "United Kingdom", code: "GB", phoneCode: "+44", currency: "GBP", symbol: "£", region: "EUROPE" },
  { id: 10, name: "Germany", code: "DE", phoneCode: "+49", currency: "EUR", symbol: "€", region: "EUROPE" },
  { id: 11, name: "France", code: "FR", phoneCode: "+33", currency: "EUR", symbol: "€", region: "EUROPE" },
  { id: 12, name: "Italy", code: "IT", phoneCode: "+39", currency: "EUR", symbol: "€", region: "EUROPE" },
  { id: 13, name: "Spain", code: "ES", phoneCode: "+34", currency: "EUR", symbol: "€", region: "EUROPE" },
];

